const Animation = function () {
    $(document).ready(function() {

        let artistSections = document.querySelectorAll('.artist-section');
        artistSections.forEach((el, i) => {
            ScrollTrigger.create({
                trigger: el,
                markers: false,
                start: "top bottom",
                onEnter: artistAnimation
            });
        });
        
        ////////// ARTIST PAGE  //////////
        function artistAnimation () {
            $('.artist-swiper').find('.swiper-slide').each(function(index) {
                $(this).addClass('animate');
                $(this).css('transition-delay', (index * 0.15) + 's');
                $(this).find('img').addClass('animate');
            });
    
            // On slide click - Uncomment after Jonathan enters content
            $('.artist-swiper .swiper-slide').on('click', function () {
                $('.artist-swiper').addClass('animate');
                $('.modal-backdrop.show').css('opacity', '0');
                $('.swiper-slide').find('img').addClass('animateClick');
                $(this).find('img').removeClass('animateClick');
                $('.artist-swiper-container').find('.tape-img').addClass('animateClick');
            });
    
            // On Close button
            $('.artist-modal .btn-close').on('click', function() {
                $('.artist-swiper').removeClass('animate');
                $('.swiper-slide').find('img').removeClass('animateClick');
                $('.artist-swiper-container').find('.tape-img').removeClass('animateClick');
            });
    
            // Passive animation
            $('.btn-artist').addClass('animate');
            $('.sw-artist').addClass('animate');
            $('.artist-controls').addClass('animate');
            $('.artist-swiper-container').find('.tape-img').addClass('animate');
            $('.artist-section .intro-section h1, .artist-section .intro-section h2').addClass('animate');
            
            // END ARTIST PAGE // 
        }
        


        ////// NAV MENU //////
        $('.main-links').find('li').each(function(index) {
            $(this).css('transition-delay', ( (0.2 + (index * 0.0875)) ) + 's');
        });
        $('.navbar-toggler').on('click', function() {
            $('#navMenu').addClass('animate');
        });
        $('#nav-close').on('click', function() {
            $('#navMenu').removeClass('animate');
        });
        $('#nav-close-desktop').on('click', function() {
            $('#navMenu').removeClass('animate');
        });
    });


    ////////// GUITARS PAGE - SCROLLTRIGGER GSAP ////////// 
    let guitarSections = document.querySelectorAll('.guitar-block');
    guitarSections.forEach((el, i) => {
        function guitarBlock () {
            el.classList.add('animate');
        }
        ScrollTrigger.matchMedia({
            "(max-width:992px)":function(){
                ScrollTrigger.create({
                    trigger: el,
                    markers: false,
                    start: "-200px bottom",
                    onEnter: guitarBlock
                });
            },
            "(min-width:992px)":function(){
                ScrollTrigger.create({
                    trigger: el,
                    markers: false,
                    start: "200px bottom",
                    onEnter: guitarBlock
                });
            }
        });
    });

    ////////// CALLOUT SECTIONS -- SCROLLTRIGGER GSAP ////////// 
    let calloutSections = document.querySelectorAll('.callout-section');
    calloutSections.forEach((el, i) => {
        function calloutSection () {
            el.classList.add('animate');
        }
        ScrollTrigger.matchMedia({
            "(max-width:992px)":function(){
                ScrollTrigger.create({
                    trigger: el,
                    markers: false,
                    start: "50px bottom",
                    onEnter: calloutSection
                });
            },
            "(min-width:992px)":function(){
                ScrollTrigger.create({
                    trigger: el,
                    markers: false,
                    start: "100px bottom",
                    onEnter: calloutSection
                });
            }
        });
    });
}

export default Animation;